module.exports = __webpack_public_path__ + "img/general4.14aeea40.jpg";